import { THEME } from 'Assets/js/lib/constants'
;(function () {
  const components = {
    locationVerification: SAXX.Init.Component((node, ctx) => {
      const setCookie = () => {
        const expiryDate = new Date(new Date().getTime() + 31536000000)
        document.cookie = `saxxGeoPopUp=true; domain=${window.location.hostname}; path=/; expires=${expiryDate.toGMTString()}`
      }

      const targetingString = new RegExp(node.getAttribute('data-targeting'))

      node
        .closest('.modal')
        .querySelectorAll('[data-modal-close]')
        .forEach((ele) => {
          ele.addEventListener('click', () => {
            setCookie()
          })
        })

      node.addEventListener('keydown', (e) => {
        const isEscPressed = e.key === 'Escape' || e.keyCode === 27
        if (!isEscPressed) return

        setCookie()
      })

      ctx.on(THEME.userLocationIsSet, ({ userLocation = null }) => {
        if (window.location.search.includes('cross_entrance=true')) {
          setCookie()
          return
        }

        if (
          document.cookie
            .split(';')
            .find((item) => item.includes('saxxGeoPopUp=true')) ||
          !targetingString.test(userLocation)
        ) {
          return
        }

        ctx.emit(THEME.modalControlInteraction, null, {
          controlElement: node.getAttribute('data-modal-id'),
        })
      })
    }),
  }
  SAXX.Init.AddComponents(components)
})()
